import React from "react";
import { getRecoil, setRecoil } from "recoil-nexus";
import ApiController from "../../../controller/ApiController";
import LogController from "../../../controller/LogController";
import { EventType } from "../../../controller/MasterController";
import { authState } from "../../../recoil/auth";
import { eventState } from "../../../recoil/event";
import { langState, langText } from "../../../recoil/lang";
import styled from "styled-components";
import { useRecoilValue } from "recoil";

const XmasSlider = () => {
  const lang = useRecoilValue<number>(langState);

  // API 이벤트리스트 불러오기
  const getEventList = async () => {
    const user_id = getRecoil(authState).user_id;
    const user_token_id = getRecoil(authState).user_token_id;

    try {
      const response = await ApiController.store.getEventList(
        user_id,
        user_token_id
      );

      if (response && response.data) {
        const oRes = response.data;
        const eventItem = oRes.data.find(
          (item: EventType) => item.event_name === "선물상자"
        );
        if (eventItem) {
          LogController.click({
            path: "StoreSelector(MainPage)",
            params: "event",
            params2: "선물상자 슬라이더 클릭",
            index: eventItem.event_id,
          });

          setRecoil(eventState, {
            ...eventItem,
            visible: true,
            coupon: null,
          });
        }
      }
    } catch (err) {
      console.log("getAdverList err-->", err);
    }
  };

  return (
    <Style>
      <div className="slideBadge" onClick={getEventList}>
        <div className="row">
          <img
            className="bell"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_slide_bell.svg`}
            alt="bell"
          />
          <h3>CHRISTMAS EVENT</h3>
          <img
            className="cherry"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_slide_cherry.svg`}
            alt="cherry"
          />
        </div>
        <div className="row gap">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_slide_box.svg`}
            alt="box"
          />
          <h3>{langText.slider_christmas_coupon[lang]}</h3>
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_arrow_right.svg`}
            alt="open"
          />
        </div>
      </div>
    </Style>
  );
};
export default XmasSlider;

const Style = styled.div`
  .slideBadge {
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 14px;
    background: #ff3838;
    padding-left: 0;
    img.bell {
      margin-top: -11px;
    }
    img.cherry {
      margin-top: -20px;
    }

    .row {
      gap: 10px;
    }
    .row.gap {
      gap: 10px;
    }
    h3 {
      padding-top: 6px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
      font-family: "Jalnan2TTF";
    }
  }
`;
